import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getSessionData } from "../../utils/interceptors/localStorageService";
import { SelfUserClassificationEnum } from "../constants/constants";

const AUTO_LOGOUT_TIME = 3 * 60 * 1000; // 30 seconds (for testing - change back to 5 * 60 * 1000 for production)

const useAutoLogout = () => {
  const navigate = useNavigate();
  const logoutTimer = useRef(null); // Keeps track of timeout without causing re-renders

  const logoutUser = () => {
    console.log("activity log out");
    const sessionData = getSessionData();
    const classification = sessionData?.userClassification;

    console.log("No refresh token, user classification is:", classification);

    // Clear user session data
    localStorage.clear();
    localStorage.setItem("isLoggedIn", "false");
    localStorage.setItem("logoutEvent", Date.now());

    // Redirect based on user classification
    if (
      classification ===
      SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value
    ) {
      window.location.href = "/authentication/admin/login";
    } else {
      window.location.href = "/authentication/login";
    }
  };

  const resetTimer = () => {
    if (logoutTimer.current) clearTimeout(logoutTimer.current);
    logoutTimer.current = setTimeout(logoutUser, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    const handleUserActivity = () => {
      resetTimer(); // Reset logout timer on user interaction
    };

    // Attach event listeners
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    window.addEventListener("click", handleUserActivity);

    resetTimer(); // Start the timer

    return () => {
      clearTimeout(logoutTimer.current);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      window.removeEventListener("click", handleUserActivity);
    };
  }, []);

  return null; // No UI needed
};

export default useAutoLogout;
